import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { AltinnApplication } from '../../models/altinn-application/altinn-application';
import { ApplicationStatus } from '../../models/altinn-application/application-status-enum';
import { NavigationService } from '../../services/navigation.service';
import { LandingPageStateService } from '../../services/landing-page-state.service';
import { AuthorizationService } from '../../services/authorization.service';
import { ActivatedRoute } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';


@Component({
  selector: 'app-landing-page-main-container',
  templateUrl: './landing-page-main-container.component.html',
  styleUrls: ['./landing-page-main-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingPageMainContainerComponent implements OnInit {

  statusEnum = ApplicationStatus;

  step$: Observable<number>;
  application$: Observable<AltinnApplication>
  loginFailed$: Observable<boolean>;

  constructor(
    private readonly navigationService: NavigationService,
    private readonly landingpageStateService: LandingPageStateService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly authorizationService: AuthorizationService,
    private readonly oauthService: OAuthService,
  ) {
    this.application$ = this.landingpageStateService.application$;
    this.step$ = this.navigationService.step$;
    this.loginFailed$ = this.landingpageStateService.loginFailed$;
  }

  ngOnInit(): void {
    this.landingpageStateService.updateFromRoute(this.activatedRoute);
  }

  // Login happens here rather than at "Send søknad" so the user is authenticated for the whole
  // of the approval step, and so returning from ID-porten never triggers a submission.
  onNext(application: AltinnApplication) {
    this.landingpageStateService.clearLoginFailed();

    if (this.oauthService.hasValidAccessToken()) {
      this.navigationService.toDetails();
    } else {
      this.authorizationService.logIn(application.applicationID);
    }
  }

  toReceipt() {
    this.navigationService.toReceipt();
  }

  toUnauthorized() {
    this.navigationService.toError();
  }
}
